module.exports = __webpack_public_path__ + "officialStatic/img/p3.21fb0cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/p3.jpg
// module id = trmW
// module chunks = 0